/* AFIQ editorial + utility pages (blog, article, search, 404). Loaded with defer after afiq-shop.js.
   Each block bails out if its root element is missing, so one file serves all four sections. */

/* Blog index: guest chips filter + "Load more" (progressive enhancement over server-rendered cards). */
(function () {
  'use strict';
  var root = document.querySelector('[data-afiq-blog]');
  if (!root) return;
  var PAGE = parseInt(root.getAttribute('data-page-size'), 10) || 9;
  var posts = Array.prototype.slice.call(root.querySelectorAll('#posts .post'));
  var chips = root.querySelector('#chips'), more = root.querySelector('#more'), count = root.querySelector('#count');
  var guest = 'all', shown = PAGE;

  function render() {
    var list = posts.filter(function (p) { return guest === 'all' || p.getAttribute('data-guest') === guest; });
    posts.forEach(function (p) { p.style.display = 'none'; });
    list.forEach(function (p, i) { if (i < shown) p.style.display = ''; });
    if (count) count.textContent = list.length + ' post' + (list.length === 1 ? '' : 's') + (guest === 'all' ? '' : ' featuring ' + guest);
    if (more) more.style.display = list.length > shown ? '' : 'none';
    if (chips) Array.prototype.forEach.call(chips.querySelectorAll('button'), function (b) {
      var on = b.getAttribute('data-g') === guest;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  if (chips) chips.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    guest = b.getAttribute('data-g');
    shown = PAGE;
    render();
    if (window.AFIQ_UI) AFIQ_UI.track('afiq_blog_filter', { guest: guest });
  });
  if (more) more.addEventListener('click', function () { shown += PAGE; render(); });
  render();

  var news = root.querySelector('[data-afiq-news]');
  if (news) news.addEventListener('click', function (e) {
    var input = document.querySelector('#afiq-newsletter input[type=email], .news input[type=email], .news input:not([type=hidden])');
    if (!input) return;
    e.preventDefault();
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    input.focus({ preventScroll: true });
  });
})();

/* Elite (full system) link: point default CTAs at the live Elite bundle PDP. Used by article + 404. */
(function () {
  'use strict';
  var links = document.querySelectorAll('[data-afiq-full]');
  if (!links.length || !window.AFIQ_UI) return;
  var href = AFIQ_UI.bundleUrl('elite');
  Array.prototype.forEach.call(links, function (a) { a.setAttribute('href', href); });
})();

/* Article sidebar: full-system price via priceDecks + afiq_article_cta tracking. */
(function () {
  'use strict';
  var root = document.querySelector('[data-afiq-article]');
  if (!root || !window.AFIQ_UI) return;
  var UI = window.AFIQ_UI, ids = UI.VOLS;
  if (ids.length === 4) {
    var q = UI.priceDecks(ids);
    var st = root.querySelector('[data-afiq-stack]'), pr = root.querySelector('[data-afiq-price]'), sv = root.querySelector('[data-afiq-save]');
    if (st) st.outerHTML = UI.stack(ids);
    if (pr) pr.textContent = ' · ' + UI.$(q.total);
    if (sv && q.save > 0) sv.textContent = ' Save ' + UI.$(q.save) + '.';
  }
  var handle = root.getAttribute('data-handle');
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cta]');
    if (a) UI.track('afiq_article_cta', { cta: a.getAttribute('data-cta'), article: handle });
  });
})();

/* Search: "Popular right now" rows (full system + Flag + Basics) and afiq_search tracking. */
(function () {
  'use strict';
  var root = document.querySelector('[data-afiq-search]');
  if (!root || !window.AFIQ_UI) return;
  var UI = window.AFIQ_UI, P = UI.P, esc = UI.esc;
  var pop = root.querySelector('#spop');
  if (pop) {
    var rows = [];
    if (UI.VOLS.length === 4) {
      var e = UI.priceDecks(UI.VOLS);
      rows.push({ t: 'The full system · Volumes 1–4', d: 'All four volumes, 216 cards · ' + UI.$(e.total), u: UI.bundleUrl('elite'), img: P.v4 && P.v4.cutout, k: 'Bundle' });
    }
    ['fl5', 'basics'].forEach(function (id) {
      var p = P[id];
      if (p) rows.push({ t: p.title, d: (p.tag ? p.tag + ' · ' : '') + UI.$(p.price), u: UI.url(id), img: p.cutout, k: 'Deck' });
    });
    if (rows.length) pop.innerHTML = rows.map(function (x) {
      return '<a href="' + esc(x.u) + '">' + (x.img ? '<img src="' + esc(x.img) + '" alt="' + esc(x.t) + '" loading="lazy" width="70" height="56">' : '<span></span>') +
        '<span><b>' + esc(x.t) + '</b><small>' + esc(x.d) + '</small></span><em>' + esc(x.k) + '</em></a>';
    }).join('');
  }
  var q = root.getAttribute('data-q');
  if (q) UI.track('afiq_search', { search_term: q, results: parseInt(root.getAttribute('data-count'), 10) || 0 });
  root.addEventListener('click', function (ev) {
    var a = ev.target.closest('.sres a');
    if (a) UI.track('afiq_search_click', { search_term: q || '', url: a.getAttribute('href'), popular: !!a.closest('#spop') });
  });
})();
